module.exports = __webpack_public_path__ + "static/media/SvgShareFaster.62aa0e43.svg";